module.exports = __webpack_public_path__ + "static/media/hisopados_payment.66279747.svg";